import * as React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

interface IProps extends ICellRendererParams {
    onValueChange: (id: number, isChecked: boolean) => void
}

class CheckboxRenderer extends React.Component<IProps, {}> {
    checkedHandler = (e: React.FormEvent<HTMLInputElement>) => {
        let checked = e.currentTarget.checked;
        let colId = this.props.column.getColId();
        this.props.node.setDataValue(colId, checked);

        this.props.onValueChange(parseInt(this.props.data.id), checked);
    }

    render = () => {
        if (this.props.node.data.id != null)
            return (
                <input
                    type='checkbox'
                    onClick={this.checkedHandler}
                    checked={this.props.value}
                />
            );

        return null;
    }
}

export default CheckboxRenderer;